import React, { useEffect, useState } from "react";
import Button from "../../components/common/ui/Button.jsx";
import ToggleSwitch from "../../components/common/ui/Inputs/ToggleSwitch.jsx";
import TextAreaInput from "../../components/common/ui/Inputs/TextAreaInput.jsx";
import Table from "../../components/common/table/Table.jsx";
import { useDispatch, useSelector } from "react-redux";
import { maintenanceAction, authActions } from "../../_store/index.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import paymentGatewaySchema from "../../validation/paymentGatewaySchema.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import { StoredProcedures } from "../../_helpers/enumerator";

function PaymentGatewayMaintenance({ key }) {
  const { paymentGatewayList, loading } = useSelector((x) => x.maintenance);

  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const [paymentGateway, setPaymentGateway] = useState({
    IsPaypalActive: 0,
    IsStripeActive: 0,
    Notes: "",
    IsPaypalActiveInMobile: 0,
    IsStripeActiveInMobile: 0,
    IsGoogleActiveMobile: 0,
    MaintenanceNotesforMobile: "",
    CreatedBy: 0,
    PageNo: 1,
    RowCountPerPage: 10,
  });

  let updatedPayment = { ...paymentGateway };

  const [errorMessage, setErrorMessage] = useState({});

  // const [pagination, setPagination] = useState({
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  // });

  const dispatch = useDispatch();

  useEffect(() => {
    if (paymentGatewayList?.DataList?.length > 0) {
      setPaymentGateway({
        ...paymentGateway,
        // IsPaypalActive: paymentGatewayList?.DataList[0]?.IsPaypalActive,
        // IsStripeActive: paymentGatewayList?.DataList[0]?.IsStripeActive,
        Notes: paymentGatewayList?.DataList[0]?.Notes,
        // IsPaypalActiveInMobile:
        //   paymentGatewayList?.DataList[0]?.IsPaypalActiveInMobile,
        // IsStripeActiveInMobile:
        //   paymentGatewayList?.DataList[0]?.IsStripeActiveInMobile,
        MaintenanceNotesforMobile:
          paymentGatewayList?.DataList[0]?.MaintenanceNotesforMobile,
        CreatedBy: user?.ManagementUserID,
      });
    }
  }, [paymentGatewayList, isPageReloading]);

  useEffect(() => {
    dispatch(
      maintenanceAction.LoadPaymentGatewayMaintenanceList({
        PageNo: paymentGateway?.PageNo,
        RowCountPerPage: paymentGateway?.RowCountPerPage,
      })
    );
    setPaymentGateway({
      ...paymentGateway,
      CreatedBy: user.ManagementUserID,
    });
  }, [
    paymentGateway.PageNo,
    paymentGateway.RowCountPerPage,
    commonFacilityCode,
  ]);

  const column = [
    {
      name: "Paypal (Web)",
      selector: (row) => row.IsPaypalActiveStatus,
      sortable: false,
    },
    {
      name: "Stripe (Web)",
      selector: (row) => row.IsStripeActiveStatus,
      sortable: false,
    },
    {
      name: "Notes (Web)",
      selector: (row) => row.Notes,
      sortable: false,
    },
    {
      name: "Paypal (Mobile)",
      selector: (row) => row.IsPaypalActiveStatusInMobile,
      sortable: false,
    },
    {
      name: "Stripe (Mobile)",
      selector: (row) => row.IsStripeActiveStatusInMobile,
      sortable: false,
    },
    {
      name: "Google (Mobile)",
      selector: (row) => row.IsGoogleActiveStatusInMobile,
      sortable: false,
    },
    {
      name: "Notes (Mobile)",
      selector: (row) => row.MaintenanceNotesforMobile,
      sortable: false,
    },
    {
      name: "Modified Date",
      selector: (row) => row.CreatedDate,
      sortable: false,
    },
  ];

  const handleChanePageNo = (value) => {
    setPaymentGateway({
      ...paymentGateway,
      PageNo: value,
    });
  };

  const handleRowPerPage = (value) => {
    setPaymentGateway({
      ...paymentGateway,
      RowCountPerPage: value,
      PageNo: 1,
    });
  };

  const chk = () => {
    const errorFields = Object.keys(errorMessage);

    errorFields.forEach((field) => {
      // Conditions to clear errors for Notes and MaintenanceNotesforMobile
      const shouldClearError =
        (field === "Notes" && updatedPayment.IsPaypalActive === 1) ||
        (field === "MaintenanceNotesforMobile" &&
          updatedPayment.IsPaypalActiveInMobile === 1);

      if (shouldClearError) {
        // Clear the error message for the field
        setErrorMessage((prev) => ({
          ...prev,
          [field]: "",
        }));

        // Remove the error class from the input element
        const element = document.querySelector(`[name=${field}]`);
        if (element?.classList.contains("input-error")) {
          element.classList.remove("input-error");
        }
      }
    });
  };

  const handleCheckboxClick = (e, name) => {
    let { checked } = e?.target;

    updatedPayment[name] = checked ? 1 : 0;

    setPaymentGateway(updatedPayment);

    if (errorMessage?.Notes || errorMessage?.MaintenanceNotesforMobile) {
      chk();
    }
  };

  const handleNotes = (e, name) => {
    let { value } = e.target;

    const element = document.querySelector(`[name=${name}]`);
    if (element && element.classList.contains("input-error")) {
      element.classList.remove("input-error");
    }

    setErrorMessage((prev) => ({
      ...prev,
      [name]: "", // Clear the error message for documentName field
    }));

    setPaymentGateway({
      ...paymentGateway,
      [name]: value,
    });
  };

  const handleReset = () => {
    if (paymentGatewayList?.DataList?.length > 0) {
      setPaymentGateway({
        ...paymentGateway,
        IsPaypalActive: paymentGatewayList?.DataList[0]?.IsPaypalActive,
        IsStripeActive: paymentGatewayList?.DataList[0]?.IsStripeActive,
        Notes: paymentGatewayList?.DataList[0]?.Notes,
        IsPaypalActiveInMobile:
          paymentGatewayList?.DataList[0]?.IsPaypalActiveInMobile,
        IsStripeActiveInMobile:
          paymentGatewayList?.DataList[0]?.IsStripeActiveInMobile,
        IsGoogleActiveMobile:
          paymentGatewayList?.DataList[0]?.IsGoogleActiveMobile,
        MaintenanceNotesforMobile:
          paymentGatewayList?.DataList[0]?.MaintenanceNotesforMobile,
        CreatedBy: user?.ManagementUserID,
        PageNo: 1,
        RowCountPerPage: 10,
      });
    }

    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }
  };

  useEffect(() => {
    handleReset();
  }, [key]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      paymentGateway.IsPaypalActive === 0 ||
      paymentGateway.IsPaypalActiveInMobile === 0
    ) {
      setErrorMessage({});

      if (document?.getElementsByClassName("input-error").length > 0) {
        document
          .querySelectorAll(".input-error")
          .forEach((el) => el.classList.remove("input-error"));
      }

      const { error } = paymentGatewaySchema(paymentGateway);

      if (error?.details) {
        error?.details?.forEach((e) => {
          const { path } = e;
          // Set the error message for each invalid field
          setErrorMessage((prev) => ({
            ...prev,
            [path.toString()]: e.message,
          }));

          // Safely select the input element by name
          const inputElement = document.querySelector(
            `textarea[name="${path}"]`
          );
          if (inputElement) {
            // Add the input-error class if the element exists
            inputElement.classList.add("input-error");
          }
        });
        return;
      }
    }
    dispatch(
      maintenanceAction.AddPaymentGatewayMaintenance(paymentGateway)
    ).then((res) => {
      if (res.payload.IsSucceed === 1) {
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.InsertPaymentGatewaySetting,
            UserAction: `Payment gateway settings( Remarks - ${paymentGateway.Notes +
              " " +
              paymentGateway.MaintenanceNotesforMobile
              } )`,
          })
        );
        showToastNotification(
          "Payment Gateway Enabled/Disabled successfully.",
          "success"
        );
        dispatch(
          maintenanceAction.LoadPaymentGatewayMaintenanceList({
            PageNo: paymentGateway?.PageNo,
            RowCountPerPage: paymentGateway?.RowCountPerPage,
          })
        );
      } else if (res.payload.IsSucceed === -1) {
        showToastNotification(
          "Something went wrong. Please try again.",
          "error"
        );
      }
    });
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div>
        <div className="card b-r-all  p-4 mb-3">
          {/* <h4 className="form_title_uppercase text-color">
          Payment Gateway Schedule Information
        </h4> */}
          <div className="row">
            <div className="col-md-6 col-lg-6 col-sm-6 p-2 ">
              <h4 className="form_title_uppercase text-color">
                Web Application
              </h4>
              <form>
                <div className="col-md-6 d-flex maintance-label align-items-center mt-2">
                  <label
                    className="col-md-8 col-lg-4 form-label col-form-label me-2 fs-5"
                    style={{ color: "#20252aa6", fontWeight: "400" }}
                  >
                    Paypal <span className="text-danger">*</span>
                  </label>

                  <div className=" col-md-2 form-check form-switch">
                    <ToggleSwitch
                      name={`Paypal${paymentGateway.IsPaypalActive}`}
                      id={`Paypal${paymentGateway.IsPaypalActive}`}
                      checked={paymentGateway.IsPaypalActive}
                      value={paymentGateway.IsPaypalActive}
                      // disabled={paymentGateway.IsPaypalActive === 0 && true}
                      handleClick={(e) =>
                        handleCheckboxClick(e, "IsPaypalActive")
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6 d-flex maintance-label align-items-center mt-2">
                  <label
                    className="col-md-8 col-lg-4 form-label col-form-label me-2 fs-5"
                    style={{ color: "#20252aa6", fontWeight: "400" }}
                  >
                    Stripe <span className="text-danger">*</span>
                  </label>

                  <div className="col-md-2 form-check form-switch">
                    <ToggleSwitch
                      name={`Stripe${paymentGateway.IsStripeActive}`}
                      id={`Stripe${paymentGateway.IsStripeActive}`}
                      checked={paymentGateway.IsStripeActive}
                      value={paymentGateway.IsStripeActive}
                      handleClick={(e) =>
                        handleCheckboxClick(e, "IsStripeActive")
                      }
                    />
                  </div>
                </div>
                <div className="col-md-4 w-75 mt-2">
                  <TextAreaInput
                    name="Notes"
                    id="Notes"
                    label="Notes"
                    value={paymentGateway?.Notes}
                    handleChange={(e) => handleNotes(e, "Notes")}
                    placeholder=""
                    required={
                      paymentGateway.IsPaypalActive === 0 ? true : false
                    }
                    errorMessage={errorMessage}
                    rows={3} // Number of rows for the textarea
                    disabled={false}
                    maxLength={100}
                  />
                </div>
                {/* </div> */}
              </form>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-6 p-2 ">
              <h4 className="form_title_uppercase text-color">
                Mobile Application
              </h4>
              <form
              // onSubmit={handleSubmit}
              >
                {/* <div className="row"> */}

                <div className="col-md-6 d-flex maintance-label align-items-center mt-2">
                  <label
                    className="col-md-8 col-lg-4 form-label col-form-label me-2 fs-5"
                    style={{ color: "#20252aa6", fontWeight: "400" }}
                  >
                    Paypal <span className="text-danger">*</span>
                  </label>

                  <div className="col-md-2 form-check form-switch">
                    <ToggleSwitch
                      name={`Paypal${paymentGateway.IsPaypalActiveInMobile}`}
                      id={`Paypal${paymentGateway.IsPaypalActiveInMobile}`}
                      checked={paymentGateway.IsPaypalActiveInMobile}
                      value={paymentGateway.IsPaypalActiveInMobile}
                      handleClick={(e) =>
                        handleCheckboxClick(e, "IsPaypalActiveInMobile")
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6 d-flex maintance-label align-items-center mt-2">
                  <label
                    className="col-md-8 col-lg-4 form-label col-form-label me-2 fs-5"
                    style={{ color: "#20252aa6", fontWeight: "400" }}
                  >
                    Stripe <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-2 form-check form-switch">
                    <ToggleSwitch
                      name={`Stripe${paymentGateway.IsStripeActiveInMobile}`}
                      id={`Stripe${paymentGateway.IsStripeActiveInMobile}`}
                      checked={paymentGateway.IsStripeActiveInMobile}
                      value={paymentGateway.IsStripeActiveInMobile}
                      handleClick={(e) =>
                        handleCheckboxClick(e, "IsStripeActiveInMobile")
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 d-flex maintance-label align-items-center mt-2">
                  <label
                    className="col-md-8 col-lg-4 form-label col-form-label me-2 fs-5"
                    style={{ color: "#20252aa6", fontWeight: "400" }}
                  >
                    Google <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-2 form-check form-switch">
                    <ToggleSwitch
                      name={`Google${paymentGateway.IsGoogleActiveMobile}`}
                      id={`Google${paymentGateway.IsGoogleActiveMobile}`}
                      checked={paymentGateway.IsGoogleActiveMobile}
                      value={paymentGateway.IsGoogleActiveMobile}
                      handleClick={(e) =>
                        handleCheckboxClick(e, "IsGoogleActiveMobile")
                      }
                    />
                  </div>
                </div>
                <div className="col-md-4 w-75 mt-2">
                  <TextAreaInput
                    name="MaintenanceNotesforMobile"
                    id="MaintenanceNotesforMobile"
                    label="Notes"
                    value={paymentGateway?.MaintenanceNotesforMobile}
                    handleChange={(e) =>
                      handleNotes(e, "MaintenanceNotesforMobile")
                    }
                    placeholder=""
                    required={
                      paymentGateway.IsPaypalActiveInMobile === 0 ? true : false
                    }
                    errorMessage={errorMessage}
                    rows={3} // Number of rows for the textarea
                    disabled={false}
                    maxLength={100}
                  />
                </div>
                {/* </div> */}
              </form>
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-center mt-3 gap-3">
            <Button
              className="me-2"
              label={"Save"}
              type="submit"
              variant="danger"
              status={"success"}
              onClick={handleSubmit}
              icon={"fa-solid fa-floppy-disk"}
              disabled={false}
            />
            <Button
              className="me-2"
              label="Reset"
              type="reset"
              variant="danger"
              status={"secondary"}
              onClick={handleReset}
              icon={"fa-solid fa-rotate-right"}
              disabled={false}
            />
          </div>
        </div>

        <div className="mt-5">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <h4 className=" form_title_uppercase text-color">
              PAYMENT GATEWAY ENABLED/DISABLED HISTORY
            </h4>
          </div>

          <Table
            columns={column}
            data={paymentGatewayList.DataList}
            pagination={true}
            onChangePage={(e) => handleChanePageNo(e)} // Call API when page changes
            onChangeRowsPerPage={(e) => handleRowPerPage(e)}
            totalRowCount={paymentGatewayList?.TotalRecordCount}
            currentPage={paymentGateway?.PageNo}
            paginationPerPage={paymentGateway?.RowCountPerPage}
          />
        </div>
      </div>
    </>
  );
}

export default React.memo(PaymentGatewayMaintenance);
